import { ReactElement } from "react";
import { HubGridViewLayout } from "client/Features/Hub/HubGridViewLayout/HubGridViewLayout";
import { GridItem, Icon } from "client/Components";
import { useIsTouchDevice } from "client/Hooks";
import { generateTrackingId } from "client/Misc/utils";
import { FileThumbnailKind } from "client_legacy/Documents/fileExtensions";
import { LinkedDocumentsList } from "./LinkedDocumentsList/LinkedDocumentsList";

export type LinkedDocumentPreviewModel = {
	id: string;
	name: string;
	thumbnailKind: FileThumbnailKind;
};

export type LinkedDocumentsPreviewProps = {
	items: readonly LinkedDocumentPreviewModel[];
};

export const LinkedDocumentsPreview = (props: LinkedDocumentsPreviewProps): ReactElement => {
	const {
		items
	} = props;

	const isTouch: boolean = useIsTouchDevice();

	return (
		<LinkedDocumentsList trackingId="linked-documents-list">
			{items.map(x => (
				<HubGridViewLayout.ListItem
					key={x.id}
				>
					<GridItem
						isTouch={isTouch}
						trackingId={generateTrackingId("linked-document-item", `|${x.id}`)}
						isReadonly
					>
						<GridItem.Content
							name={x.name}
							thumbnail={
								<Icon
									value={{ kind: "svg", name: x.thumbnailKind }}
								/>
							}
						/>
					</GridItem>
				</HubGridViewLayout.ListItem>
			))}
		</LinkedDocumentsList>
	);
};
LinkedDocumentsPreview.displayName = "LinkedDocumentsPreview";